import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { InvitePeopleModalProps } from './ModalBodyProps.types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyComponent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-project-invite-people-modal" */ './InvitePeopleWithAnalytics.tsx'
		),
	{ ssr: false },
);

const AsyncCoreInvitesProjectDialogComponent = (
	props: InvitePeopleModalProps,
): React.JSX.Element => (
	<JSErrorBoundary
		id="async-project-invite-people-modal"
		packageName="jira-project-invite-people-modal"
		teamName="groot-growth"
	>
		<Placeholder name="project-invite-people-modal" fallback={null}>
			<LazyComponent {...props} />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncCoreInvitesProjectDialogComponent;
